<template>
  <div>
    <a href="#/backoffice/admin" v-if="isAdminView">← back</a>
    <h1 v-if="isAdminView">{{ company_name }}</h1>
    <h2>Signatures:{{ total_signatures }}</h2>
    <h2 v-if="isAdmin">Total documents signed:{{ total_files_singed }}
      <br/> Total data singed {{ total_kb_signed| prettyBytes(2) }}
      <br/> Avg. {{ total_kb_signed / total_files_singed| prettyBytes(2) }}
    </h2>
    <div class="table-responsive">
      <table class="table table-bordered table-hover">
        <thead>
        <tr>
          <th>Date</th>
          <th>Doc signed</th>
          <th>I/O usage</th>
          <th>Avg. usage</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="rec in statOrderByDateReverse">
          <td>{{ rec.date }}</td>
          <td>{{ rec.files_singed }}</td>
          <td>{{ rec.total_kb_signed |prettyBytes(2) }}</td>
          <td>{{ rec.total_kb_signed / rec.files_singed|prettyBytes(2) }}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import ApiService from "../../../libs/ApiService";
import _ from "lodash";

export default {
  name: "Statistics",
  props: {
    isAdminView: {
      type: Boolean,
      default: false
    },
    user_uuid: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      company_name: this.$store.state.me.user.company_name,
      isAdmin: this.$store.state.me.user.isAdmin,
      total_signatures: 0,
      total_files_singed: 0,
      total_kb_signed: 0,
      signDatesList: []
    }
  },
  computed: {
    statOrderByDateReverse() {
      return _.orderBy(this.signDatesList, function (value) {
        return new Date(value);
      }, 'desc');
    }
  },
  async created() {
    //we use this component for admin, to show the users statistics
    let url = this.isAdminView ? '/admin/user_stat/' + this.user_uuid : '/private/statistics';
    let res = await ApiService.get(url);
    if (res.data.statistics.files_singed) {
      //normalize
      for (let key in res.data.statistics.files_singed) {
        let record = {
          date: key,
          files_singed: res.data.statistics.files_singed[key]
        };
        if (key == 'total') {
          this.total_files_singed = record.files_singed;
        } else {
          this.signDatesList.push(record);
        }
      }
    }
    if (res.data.statistics.data_singed) {
      //normalize
      for (let key in res.data.statistics.data_singed) {
        //we store it as KB so convert it here to bytes fot the filter
        let total_bytes_signed = res.data.statistics.data_singed[key] * 1000;
        if (key == 'total') {
          this.total_kb_signed = total_bytes_signed;
          continue;
        }
        // get the record by date
        let objKey = this.lodash.findIndex(this.signDatesList, {date: key});
        //this should not happen, but I set it just in case
        if (objKey == -1) {
          let record = {
            date: key,
            files_singed: '-',
            total_kb_signed: total_bytes_signed
          };
        }
        //add to the date
        else {
          this.signDatesList[objKey].total_kb_signed = total_bytes_signed;
        }
      }
    }
    //when it's admin view the company name derived from the server
    if (this.isAdminView) {
      this.company_name = res.data.company_name;
    }
    this.total_signatures = res.data.statistics.total_signatures;
  }

}
</script>

<style scoped>

</style>